export default __webpack_public_path__ + "static/media/jiffy-logo.0ecada9f.png";